import { createContext, useContext, type ReactNode } from 'react';
import type { DockviewApi } from 'dockview-react';

// Lightweight context that exposes the active dockview-react API to
// descendants without prop-drilling. Set once at the TabCanvas level
// when dockview's onReady fires; every panel inside the canvas (target
// list, identity, financial snapshot, future panels) reads from here
// to register float/popout/maximize actions.

const DockviewApiContext = createContext<{ current: DockviewApi | null } | null>(null);

export function DockviewApiProvider({
  value,
  children,
}: {
  value: { current: DockviewApi | null };
  children: ReactNode;
}) {
  return <DockviewApiContext.Provider value={value}>{children}</DockviewApiContext.Provider>;
}

export function useDockviewApi(): { current: DockviewApi | null } {
  const ctx = useContext(DockviewApiContext);
  // Defensive default for tests that render panels in isolation.
  return ctx ?? { current: null };
}
